import { render, staticRenderFns } from "./UserQuestionUpdate.vue?vue&type=template&id=4c815bea&scoped=true"
import script from "./UserQuestionUpdate.vue?vue&type=script&lang=js"
export * from "./UserQuestionUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserQuestionUpdate.vue?vue&type=style&index=0&id=4c815bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c815bea",
  null
  
)

export default component.exports